angular.module("vgresiduos").controller("EditMaturityCtrl", [
	"$rootScope",
	"$stateParams",
	function ($rootScope) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, "bi/eficiencia-ambiental");
		};
	}
]);
